import validate from "/app/node_modules/.pnpm/nuxt@3.12.4_@types+node@18.19.1_rollup@4.27.3_sass@1.77.8_typescript@4.8.4_vite@3.2.5/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.12.4_@types+node@18.19.1_rollup@4.27.3_sass@1.77.8_typescript@4.8.4_vite@3.2.5/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  featured: () => import("/app/apps/explorer-plus/middleware/featured.ts")
}